// extracted by mini-css-extract-plugin
export default {"box":"Pricing_box__bV2cS","heading":"Pricing_heading__SwIrv","subHeading":"Pricing_subHeading__pm7wC","cardGroup":"Pricing_cardGroup__gWXa3"};